import { setTrackingId } from "client/Misc/utils";
import { PropsWithChildren, ReactElement } from "react";
import styles from "./SearchListItem.module.less";

export type SearchListItemProps = {
	onExecute: () => void;
	trackingId: string;
};

export const SearchListItem = (props: PropsWithChildren<SearchListItemProps>): ReactElement => {
	const {
		onExecute,
		trackingId,
		children
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}
			onClick={() => onExecute()}
		>
			{children}
		</div>
	);
};
SearchListItem.displayName = "SearchListItem";
